import { VSwitch } from 'vuetify/lib/components/VSwitch';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VSwitch,{attrs:{"label":"dark","hide-details":"","dense":""},model:{value:(_vm.dark),callback:function ($$v) {_vm.dark=$$v},expression:"dark"}})}
var staticRenderFns = []

export { render, staticRenderFns }